import { PropsWithChildren } from 'react';

import { screenBody, screenContent } from './WizardScreen.css';

export const WizardScreenContent = ({ children }: PropsWithChildren) => {
    return (
        <div className={screenBody}>
            <div className={screenContent}>{children}</div>
        </div>
    );
};
